
import CustomButton from "./button";
import { AlertTriangle,MessageSquare,X,Bot } from "lucide-react";
import {Modal,Form} from "react-bootstrap";
import ReactQuilInput from "./ReactQuilInput";
import { useState } from "react";


const DRAWER_CSS = `
.lywo-bubble { max-width: 80%; }
.lywo-bubble--me { border-top-right-radius: .25rem !important; }
.lywo-bubble--ai { border-top-left-radius: .25rem !important; }
.lywo-label { font-size: 10px; letter-spacing: .04em; }
.lywo-section-title { letter-spacing: .08em; }
.lywo-card-label { font-size: 10px; }
.btn-primary-brand { background: var(--brand-primary); border-color: var(--brand-primary); color: #fff; }
`;

let transcript =[
      { sender: 'AI', text: "Hi Alexia! I'm LYWO's AI assistant. Ready for a quick chat about the Senior Frontend role?" },
      { sender: 'Candidate', text: "Yes, absolutely! Happy to chat." },
      { sender: 'AI', text: "Great. First, are you still interested in this position and comfortable with a hybrid work setup in New York?" },
      { sender: 'Candidate', text: "Yes, I am currently based in Brooklyn so hybrid in NY is perfect." },
      { sender: 'AI', text: "Let's dive into a quick technical question. How do you handle state management in a large-scale React application?" },
      { sender: 'Candidate', text: "I typically use Redux Toolkit for global state, but I lean heavily on React Query for server state caching. It keeps the UI snappy and reduces boilerplate." }
    ]

export default function CandidateReview({candidate,setShowReview}) {


        const [mails,setMails] = useState({isOpen:false,type:''})


              const [showMailTest,setShowMailTest] = useState(false)


     const getBadgeClass = (rec) => {
    switch(rec) {
      case 'Recommended': return 'badge-excellent';
      case 'Maybe Not': return 'badge-normal';
      case 'Unsure': return 'badge-unsure';
      default: return 'badge-unsure';
    }
  };

    return(
        <>
              <style>{DRAWER_CSS}</style>
        
              <div className="d-flex flex-column bg-white" style={{ height: '100vh' }}>
        
                {/* HEADER */}
                <div className="p-4 border-bottom d-flex justify-content-between align-items-start bg-white">
                  <div>
                    <div className="d-flex align-items-center gap-3 mb-1">
                      <h1 className="h3 m-0">Alexia Vance</h1>
                      <span 
                      className={`badge rounded-pill ${getBadgeClass('Recommended')}`}
                      >
                        AI: {candidate?.recommendation}
                      </span>
                    </div>
                    <p className="small text-muted m-0">
                      Applied: Oct 24, 2026 • ID: 4202
                    </p>
        
                    {candidate?.fraudFlag && (
                      <div className="mt-2 d-flex align-items-center gap-2 p-2 bg-danger-subtle border border-danger-subtle text-danger rounded small fw-medium">
                        <AlertTriangle size={16} />
                        {candidate?.fraudReason}
                      </div>
                    )}
                  </div>
        
                  <button
                    onClick={() => {setShowReview(false)}}
                    className="btn btn-sm btn-light text-secondary rounded-circle p-1 lh-1 border-0"
                  >
                    <X size={20} />
                  </button>
                </div>
        
                {/* BODY */}
                <div className="flex-grow-1 overflow-auto p-4 bg-light">
        
                  {/* Summary */}
                  <div className="mb-4">
                    <h4 className=" mb-2 ">
                      Screening Summary
                    </h4>
                    <div className="row g-2">
                      {[
                        { label: 'Interest', status: 'Verified' },
                        { label: 'Requirements', status: 'Met (Hybrid NY)' },
                        { label: 'Technical', status: 'Completed' },
                        // { label: 'Behaviour', status: 'Skipped' },
                        { label: 'Logistics', status: 'Available Mon-Wed' },
                        { label: 'Referrals', status: 'None' },
                      ].map((item, idx) => (
                        <div className="col-6" key={idx}>
                          <div className="bg-white p-2 rounded border shadow-sm d-flex flex-column h-100">
                            <span className="text-muted">
                              {item.label}
                            </span>
                            <span className="fw-bold">{item.status}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
        
                  {/* Transcript */}
                  <div>
                    <h4 className=" mb-3  d-flex align-items-center gap-2">
                      <MessageSquare size={13} /> Raw Chat Transcript
                    </h4>
                    <div className="d-flex flex-column gap-3">
                      {transcript?.map((msg, idx) => (
                        <div
                          key={idx}
                          className={`d-flex ${msg.sender === 'Candidate' ? 'justify-content-end' : 'justify-content-start'}`}
                        >
                          {msg.sender === 'System' ? (
                            <div className="w-100 text-center my-1 small fw-bold text-danger bg-danger-subtle py-1 rounded border border-danger-subtle">
                              {msg.text}
                            </div>
                          ) : (
                            <div
                              className={`lywo-bubble rounded-3 p-2 small ${
                                msg.sender === 'Candidate'
                                  ? 'btn-primary-brand lywo-bubble--me'
                                  : 'bg-white border text-dark shadow-sm lywo-bubble--ai'
                              }`}
                            >
                              {msg.sender === 'AI' && (
                                <div className="lywo-label fw-bold text-primary mb-1 d-flex align-items-center gap-1">
                                  <Bot size={12} /> Lywo Ai
                                </div>
                              )}
                              {msg.text}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
        
                {/* FOOTER */}
                <div className="p-3 border-top bg-white d-flex justify-content-end gap-3 shadow-sm">
                  
                    <CustomButton title="Respctfully Decline" buttonType="secondary"
                    handleClick={() => setMails({isOpen:true,type:""})}
                    />
                    <CustomButton title="Advance Candidate" 
                    handleClick={() => setMails({isOpen:true,type:""})}
                    />
                  {/* <button className="btn btn-link text-danger px-4 text-decoration-none">
                    Respectful Decline
                  </button>
                  <button className="btn btn-primary-brand px-4 d-flex align-items-center gap-1">
                    Advance Candidate <ChevronRight size={16} />
                  </button> */}
                </div>
              </div>
              <Modal show={mails.isOpen} 
                            onHide={()=>setMails({isOpen:false,type:""})}
                             zIndex={1200}
                             size="lg" dialogClassName="modal-h-650"
                              backdropClassName="drawer-modal-backdrop"   // raise the backdrop
                style={{ zIndex: 1200 }} 
                             >
                                        <Modal.Header closeButton className="custom-close-btn">
                                            {/* <h6 className="mb-0 mt-1">Application</h6> */}
                                        </Modal.Header>
                                        <Modal.Body>
                                            <div>
              
                                                    <div className="d-flex mt-1">
                                                        <Form.Label style={{ width: "50px" }}>To</Form.Label>
                            
                                                        <p>
                                                            <span>1</span> Respondent
                                                            {/* {selects.length === 1 ? "" : "s"} selected */}
                                                        </p>
                                                    </div>
                                                     <div className="d-flex">
                                                                                <Form.Label className="" style={{ width: "50px" }}>
                                                                                    Excl
                                                                                </Form.Label>
                                                                                <p>
                                                                                  {2} Not Interested,   {1} Completed
                                                                                </p>
                                                                            </div>
                                                <Form.Group>
                                                    <div className="d-flex align-items-center mb-3">
                                                        <Form.Label className="me-2">Subject</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                          //   value={subject}
                                                          //   onChange={(e) => setSubject(e.target.value)}
                                                        />
                                                    </div>
                                                </Form.Group>
                                                {/* {from && ( */}
                                                    <div className="d-flex mt-1">
                                                        <Form.Label className="me-1" style={{ width: "50px" }}>
                                                            From
                                                        </Form.Label>
                                                        <p>sameer.kutty@cloudxperte.com</p>
                                                    </div>
                                                {/* )} */}
                                                <Form.Group>
                                                    <div className="d-flex align-items-center mb-3">
                                                        <Form.Label className="me-2" style={{ width: "43px", marginTop: '5px' }}>
                                                            Cc
                                                        </Form.Label>
                                                        <div
                                                            style={{
                                                                flex: 1,
                                                                // border: "1px solid #ccc",
                                                                // borderRadius: "5px",
                                                            }}
                                                        >
                                                            {/* {ccEmails.map((x, index) => (
                                                                <Badge
                                                                    pill
                                                                    key={index}
                                                                    bg="secondary"
                                                                    className="m-1"
                                                                    style={{ cursor: "pointer" }}
                                                                    onClick={() => removeEmail(x)}
                                                                >
                                                                    {x}
                                                                </Badge>
                                                            ))} */}
                                                            <Form.Control
                                                                type="text"
                                                              //   value={inputValue}
                                                              //   onChange={(e) => setInputValue(e.target.value)}
                                                                placeholder="Add email and press enter"
                                                              //   onKeyDown={handleKeyDown}
                            
                                                                style={{
                                                                    border: "none !important",
                            
                            
                                                                }}
                                                            ></Form.Control>
                                                        </div>
                                                    </div>
                                                </Form.Group>
                                                <div style={{ height: "200px" }}>
                                                    <ReactQuilInput/>
                                                </div>
                                            </div>
                                            <div className="d-flex justify-content-between mt-4 align-items-center">
                                              <div className=" d-flex mt-1 ml-1 gap-2">
                                      <span> Use last sent template</span>
              
                                      <Form.Check
                                          // checked={isDefaultEmailContent}
                                          type="switch"
                                          id={"custom-switch"}
                                          style={{ marginTop: '-6pX' }}
                                          className="custom-switch"
                                         
                                      // disabled={isDefaultEmailContent}
                                      />
                                      <span style={{ marginLeft: '0px' }}>Fetch default template</span>
                                  </div>
                                                <div className="d-flex gap-1">
                                                  <CustomButton
                                                  title='Test Email'
                                                  handleClick={()=>{
                                                    setShowMailTest(true)
                                                  }}
                                                  buttonType='secondary'
                                                  />
                                                  <CustomButton
                                                  title="Send"
                                                  handleClick={()=>{}}
                                                  />
                                                </div>
                                            </div>
                                        </Modal.Body>
                                    </Modal>
              
               <Modal show={showMailTest}
                centered 
                onHide={()=>setShowMailTest(false
                  
                )}
                     backdropClassName="drawer-modal-backdrop-two"   // raise the backdrop
                style={{ zIndex: 1300 }} 
               
               size="lg" dialogClassName="modal-h-650">
                          <Modal.Header closeButton className="custom-close-btn">
                              <h6 className="mb-0 mt-1">Test Email</h6>
                          </Modal.Header>
                          <Modal.Body>
                              <div>
                                  <Form.Group>
                                      {/* {from && ( */}
                                          <div className="d-flex">
                                              <Form.Label style={{ width: "50px" }}>From</Form.Label>
              
                                              <p>{"Sameer.kutty@cloudxperte.com"}</p>
                                          </div>
                                      {/* )} */}
                                  </Form.Group>
                                  <Form.Group>
                                      <div className="d-flex align-items-center mb-3">
                                          <Form.Label style={{ width: "50px", marginTop: '5px' }}>To </Form.Label>
                                          <div
                                              style={{
                                                  flex: 1,
                                                  // border: "1px solid #ccc",
                                                  // borderRadius: "5px",
                                              }}
                                          >
                                              {/* {toEmails.map((x, index) => (
                                                  <Badge
                                                      pill
                                                      key={index}
                                                      bg="secondary"
                                                      className="m-1"
                                                      style={{ cursor: "pointer" }}
                                                      onClick={() => removeEmailTest(x)}
                                                  >
                                                      {x}
                                                  </Badge>
                                              ))} */}
                                              <Form.Control
                                                  type="text"
                                                  // value={inputValueTest}
                                                  // onChange={(e) => setInputValueTest(e.target.value)}
                                                  placeholder="Add email and press enter"
                                                  // onKeyDown={handleKeyDownTest}
                                                  className="border-0"
                                              // style={{
                                              //   border: "none",
                                              //   display: "inline-block",
                                              //   width: "auto",
                                              // }}
                                              ></Form.Control>
                                          </div>
                                      </div>
                                  </Form.Group>
                                  <div style={{ height: "200px" }}>
                                    <ReactQuilInput/>
                                      
                                  </div>
                              </div>
                              <div className="row justify-content-end mt-4">
                                  <div className="col-2 d-flex justify-content-end">
                                    <CustomButton
                                    title="Send"
                                    handleClick={()=>{}}
                                    />
                                  </div>
                              </div>
                          </Modal.Body>
                      </Modal>
            </>
    )

}